import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Button, Label, Segment, Divider, Icon } from 'semantic-ui-react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

const marginTop10 = {
  marginTop: 10,
};

const spacerStyle = {
  paddingTop: 15,
};

class CreatorLinkGenerator extends Component {
  constructor() {
    super();
    this.state = {
      copied: false,
    };
  }

  render() {
    const { id } = this.props;
    const origin = _.get(window, 'origin', 'https://app.dyzio.co');
    const url = `${origin}/creator/${id}`;
    const { copied } = this.state;
    return (
      <Segment>
        <h3>Authorisation Link</h3>
        <div style={spacerStyle} />
        <p>Copy the authorisation link and simply email it to the influencer for them to authorise.</p>
        <Label fluid style={marginTop10}>
          <Icon name="linkify" /> {url}
        </Label>
        <Divider hidden fitted />
        <CopyToClipboard
          text={url}
          onCopy={() => this.setState({ copied: true })}
        >
          <Button color="pink" icon labelPosition="left" style={marginTop10}>
            <Icon name={copied ? 'checkmark' : 'copy'} />
            { copied ? 'Copied ' : 'Copy Authorisation link' }
          </Button>
        </CopyToClipboard>
      </Segment>
    );
  }
}

CreatorLinkGenerator.propTypes = {
  id: PropTypes.string.isRequired,
};

export default CreatorLinkGenerator;



/** WEBPACK FOOTER **
 ** ./src/components/creator-link-generator/index.js
 **/